import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Tabs } from "../../../../stories/Tabs/Tabs";
import classes from "./Todo.module.css";
import {
  SmileIconRed,
  LessonRequestsIcon,
  StudentEvaluationIcon,
  coachDemoImg,
} from "../../../../constant/imagePath";
import { CoachTodoLessonCard } from "../../../../stories/CoachTodoLessonCard/CoachTodoLessonCard";
import { Button } from "../../../../stories/Button/Button";
import { InputWithSearchIcon } from "../../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { DropDown } from "../../../../stories/DropDown/DropDown";
import { DashboardSidebarWithCalendar } from "../../../../stories/DashboardSidebarWithCalendar/DashboardSidebarWithCalendar";
import TodoWithoutFinishingOnBoarding from "../TodoWithoutFinishingOnBoarding/TodoWithoutFinishingOnBoarding";
import EvaluatePerformance from "../EvaluatePerformance/EvaluatePerformance";
import CancelLesson from "../../../Modals/CoachFlow/Dashboard/CancelLesson/CancelLesson";
import moment from "moment";
import { useHistory } from "react-router-dom";

// No Data Component
function NoData({ icon, title, tagline, style }) {
  return (
    <>
      <div className={classes.noData}>
        <Row className={`g-0 ${classes.noDataRow}`} style={{ height: "100%" }}>
          <Col md={12} className={classes.firstCol}>
            <div style={style}>
              <img src={icon} />
              <h4
                style={{
                  ...Fonts.h4,
                  color: Colors.neutralShadesOfNero,
                  fontSize: "26px",
                }}
              >
                {title}
              </h4>
              <p>{tagline}</p>
            </div>
          </Col>
          <Col md={12} className={classes.lastCol}>
            <div>
              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
                Maybe we can help speed up the process by answering some{" "}
                <span style={{ ...Fonts.p2, color: Colors.mainBlue }}>
                  questions
                </span>
                ?
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

//Component Render on Profile Reports
function ProfileReport({
  type,
  data
}) {
  const history = useHistory()
  return (
    <div
      className={classes.profileReport}
      style={{ borderBottomColor: Colors.neutralShadesOfWhisper }}
    >
      <Row>
        <Col md={7}>
          {data?.type === "certificate" && (
            <p
              style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
              className={classes.heading}
            >
              Your{" "}
              <h6 style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}>
                "{data?.text1}"
              </h6>{" "}
              certificate has been expired.
            </p>
          )}
          {data?.type === "decline" && (
            <>
              <p
                style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
                className={classes.heading}
              >
                Your onboarding has been{" "}
                <h6 style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}>
                  {data?.text1}
                </h6>
              </p>
              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
                {data?.text2}
              </p>
            </>
          )}
        </Col>
        <Col md={5}>
          <div className={classes.btns}>
            <Button
              label={'Contact us'}
              onClick={() => history.push('/contact-us')}
              customStyle={{
                marginRight: "8px",
                minWidth: "108px",
                padding: "14px 24px 14px 24px",
                width: "max-content",
              }}
            />
            <Button
              label={data?.status == 'declined' ? "Go to onboarding" : "Add certificate"}
              onClick={() => data?.status == 'declined' ? history.push('/on-boarding') : ""}
              primary={true}
              customStyle={{
                height: "48px",
                padding: "14px 24px 14px 24px",
                width: "max-content",
                minWidth: "144px",
              }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default function Todo() {
  const history = useHistory()
  const [tab, setTab] = useState({ label: "Lesson Requests" });
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState({ label: "All", value: "all" });
  const [isFinishOnBoarding, setIsFinishOnBoarding] = useState(false);
  const [isEvaluate, setIsEvaluate] = useState(false);

  const [locations, setLocations] = useState();

  // Dummy Data
  const lessonRequestsData = [
    {
      userData: {
        displayName: "Tyler",
        profile: coachDemoImg,
      },
      startTime: moment(moment().add(-3, "hours").format())
        .add(0, "days")
        .format(),
      endTime: moment(moment().add(3, "hours").format())
        .add(0, "days")
        .format(),
      eventDate: moment().add(0, "days").format(),
      type: "1-on-1",
      title: "Tennis Lesson",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      price: 64,
      status: "upcoming",
      timeLeft: "14 hrs",
    },
    {
      userData: {
        displayName: "Kate",
        profile: coachDemoImg,
      },
      startTime: moment(moment().add(-3, "hours").format())
        .add(0, "days")
        .format(),
      endTime: moment(moment().add(3, "hours").format())
        .add(0, "days")
        .format(),
      eventDate: moment().add(0, "days").format(),
      type: "1-on-1",
      title: "Tennis Lesson",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      price: 64,
      status: "accepted",
      timeLeft: "14 hrs",
    },
    {
      userData: {
        displayName: "Tyler",
        profile: coachDemoImg,
      },
      startTime: moment(moment().add(-3, "hours").format())
        .add(0, "days")
        .format(),
      endTime: moment(moment().add(3, "hours").format())
        .add(0, "days")
        .format(),
      eventDate: moment().add(0, "days").format(),
      type: "1-on-1",
      title: "Tennis Lesson",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      price: 64,
      status: "pending",
      timeLeft: "14 hrs",
    },
  ];

  const studentEvaluationData = [
    {
      userData: {
        displayName: "Tyler",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "$64",
      timeLeft: "14 hrs",
      message: "absdsd",
      status: "evaluate",
      requestType: "1-on-1 Tennis Lesson",
    },
    {
      userData: {
        displayName: "Kate",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "$64",
      timeLeft: "14 hrs",
      status: "evaluate",
      requestType: "1-on-1 Tennis Lesson",
    },
    {
      userData: {
        displayName: "Tyler",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "$64",
      timeLeft: "14 hrs",
      status: "read-evaluation",
      requestType: "1-on-1 Tennis Lesson",
    },
  ];

  const profileReportsData = [
    {
      text1: "Certificate Name",
      type: "certificate",
      status: 'expired',
      btnText1: "Contact us",
      btnText2: "Add certificate",
    },
    {
      text1: "decline",
      text2:
        "Since onboarding check wasn’t approved - your account remains private.",
      type: "decline",
      status: 'declined',

      btnText1: "Contact us",
      btnText2: "Go to onboarding",
    },
  ];
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [data, setData] = useState(lessonRequestsData);
  const [filterData, setFilterData] = useState([]);

  //

  // useEffect(() => {
  //   if (status?.value == "all") {
  //     setFilterData(data);
  //   }
  //   if (status?.value == "not-evaluated") {
  //     setFilterData(data?.filter((item) => item.type == "evaluate"));
  //   }
  //   if (status?.value == "evaluated") {
  //     setFilterData(data?.filter((item) => item.type == "read-evaluation"));
  //   }
  // }, [status]);

  useEffect(() => {
    if (tab?.label == "Lesson Requests") {
      setData(lessonRequestsData);
    }
    if (tab?.label == "Student Evaluation") {
      setData(studentEvaluationData);
    }
    if (tab?.label == "Profile reports") {
      setData(profileReportsData);
    }
  }, [tab]);
  console.log({ data }, tab);

  return (
    <>
      <style jsx>{`
        @media screen and (min-width: 1700px) {
          .customCol1 {
            width: 20%;
          }
          .customCol2 {
            width: 80%;
          }
        }
      `}</style>

      <div
        className={classes.todoPage}
        style={{
          background: Colors.white,
          ...(data?.length > 0 && { height: "100vh" }),
        }}
      >
        {!isFinishOnBoarding ? (
          <TodoWithoutFinishingOnBoarding
            setIsFinishOnBoarding={setIsFinishOnBoarding}
          />
        ) : isEvaluate ? (
          <EvaluatePerformance setIsEvaluate={setIsEvaluate} />
        ) : (
          <Row className={`g-0 ${[classes.row].join(" ")}`}>
            <Col lg={4} xl={3} className={"customCol1"}>
              {/* Sidebar With Calendar */}
              <DashboardSidebarWithCalendar
                isSelectRange
                locations={locations}
                setLocations={setLocations}
                customStyle={{ minHeight: "100vh", overflowY: "auto" }}
              />
            </Col>
            {/* Main Page */}
            <Col
              lg={8}
              xl={9}
              className={`customCol2 ${classes.todoContainer}`}
            >
              {/*  */}
              <Col md={12}>
                <h3
                  style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
                  className={`${[classes.mainHeading].join(" ")}`}
                >
                  Todo
                </h3>
              </Col>
              <Col md={12}>
                <Tabs
                  state={tab}
                  setState={setTab}
                  tabsData={[
                    { label: "Lesson Requests" },
                    { label: "Student Evaluation" },
                    { label: "Profile reports" },
                  ]}
                />
              </Col>
              <Col md={12}>
                {data?.length < 1 && tab?.label === "Lesson Requests" && (
                  <NoData
                    icon={LessonRequestsIcon}
                    title={"You have no lesson requests yet"}
                    tagline={
                      "As soon as the student decides to take a lesson with you it will appear in this list."
                    }
                  />
                )}
                {data?.length < 1 && tab?.label === "Student Evaluation" && (
                  <NoData
                    icon={StudentEvaluationIcon}
                    title={"You have no student evaluations yet"}
                    tagline={
                      "As soon as you do the first lesson, student evaluation will appear here."
                    }
                  />
                )}
                {data?.length < 1 && tab?.label === "Profile reports" && (
                  <NoData
                    icon={SmileIconRed}
                    title={"You have no profile reports"}
                    tagline={"We will let you know if there are any issues."}
                  />
                )}

                {data?.length > 0 && tab?.label === "Lesson Requests" && (
                  <>
                    <div className={classes.searchInput}>
                      <InputWithSearchIcon state={search} setter={setSearch} />
                    </div>
                    {data?.map((item) => {
                      return <CoachTodoLessonCard data={item}
                        onClick1={(e) => {
                          if (e == 'accepted')
                            history.push('/chat')

                        }}
                        onClick2={(e) => {
                          // if (e == 'pending')
                          // history.push('/chat')
                          if (e == 'accepted')
                            setShowCancelModal(true)

                        }}
                      />
                    })}
                  </>
                )}
                <CancelLesson
                  show={showCancelModal}
                  setShow={setShowCancelModal}
                />

                {data?.length > 0 && tab?.label === "Student Evaluation" && (
                  <>
                    <div className={classes.searchInputWithDropDown}>
                      <InputWithSearchIcon state={search} setter={setSearch} />
                      <DropDown
                        customStyle={{
                          minWidth: "192px",
                          marginLeft: "4px",
                        }}
                        options={[
                          { label: "All", value: "all" },
                          { label: "Evaluated", value: "evaluated" },
                          { label: "Not evaluated", value: "not-evaluated" },
                        ]}
                        state={status}
                        setter={setStatus}
                      />
                    </div>
                    {data?.map((item) => {
                      return (
                        <CoachTodoLessonCard
                          data={item}
                          onClick1={() => setIsEvaluate(true)}
                        />
                      );
                    })}
                  </>
                )}
                {data?.length > 0 && tab?.label === "Profile reports" && (
                  <>
                    <div className={classes.searchInput}>
                      <InputWithSearchIcon state={search} setter={setSearch} />
                    </div>
                    {tab?.label === "Profile reports" &&
                      data?.map((item) => {
                        return <ProfileReport data={item} />;
                      })}
                  </>
                )}
              </Col>

              {/*  */}
            </Col>
          </Row>
        )}
      </div>
    </>
  );
}
